/**
 * Configuración del POST OAuth2 client-credentials (TFSM).
 * Separado de Apis/ApiService para evitar ciclos de importación con OAuthTokenManager.
 */
export const buildTokenRequestConfig = () => {
  const env = process.env.VUE_APP_API_TOKEN;

  const {
    VUE_APP_CLIENT_ID,
    VUE_APP_CLIENT_SECRET,
    VUE_APP_GRANT_TYPE,
    VUE_APP_SCOPE,
    VUE_APP_BEARER_TOKEN_AUTHORIZATION,
  } = process.env;

  const params = new URLSearchParams();
  const headers = new Headers();

  if (env === 'prod') {
    if (!VUE_APP_CLIENT_ID || !VUE_APP_CLIENT_SECRET || !VUE_APP_GRANT_TYPE || !VUE_APP_SCOPE) {
      throw new Error('Configuration error');
    }

    params.append('client_id', VUE_APP_CLIENT_ID);
    params.append('client_secret', VUE_APP_CLIENT_SECRET);
    params.append('grant_type', VUE_APP_GRANT_TYPE);
    params.append('scope', VUE_APP_SCOPE);
    headers.set('Content-Type', 'application/x-www-form-urlencoded');
  } else if (env === 'dev') {
    if (!VUE_APP_GRANT_TYPE || !VUE_APP_SCOPE || !VUE_APP_BEARER_TOKEN_AUTHORIZATION) {
      throw new Error('Configuration error');
    }

    params.append('grant_type', VUE_APP_GRANT_TYPE);
    params.append('scope', VUE_APP_SCOPE);
    headers.set('Authorization', VUE_APP_BEARER_TOKEN_AUTHORIZATION);
    headers.set('Content-Type', 'application/x-www-form-urlencoded');
  } else {
    throw new Error('Invalid environment');
  }

  return { params, headers };
};
